<template>
    <div class="popup" v-show="isShow" v-cloak>
        <div class="content" id="videoTaskListPopup">
            <div class="title">
                <div class="icon white-close dialog-close" @click="optionClose()"></div>
            </div>
            <div class="popup-body">
                <!-- 清除历史记录 -->
                <div @click="clearTask()" class="video_task_clear">{{$t('language.imageSaver.clearHistory')}}</div>
                <!-- tab -->
                <div class="task-tab-1">
                    <el-tabs v-model="activeTab" id="videoTaskListTab" ref="videoTaskListTab">
                        <el-tab-pane :label="$t('language.imageSaver.uploading')" name="uploading">
                            <div class="video-task-items" v-if="taskList.length > 0">
                                <div class="video-task-item" v-for="task in uploadingList" :key="task.id">
                                    <!-- 封面 -->
                                    <div class="item-cover">
                                        <el-image :src="task.thumbnailUrl" :fit="'fill'"></el-image>
                                    </div>
                                    <!-- 内容 -->
                                    <div class="item-content">
                                        <!-- 标题 -->
                                        <div class="item-content-title">{{task.fullTitle}}</div>
                                        <!-- 属性 -->
                                        <!-- <div class="item-content-attr">
                                            <span>
                                                <div class="file-type video"></div>
                                                {{task.name}}
                                            </span>
                                            <span>·</span>
                                            <span>{{task.quality}}</span>
                                            <span>·</span>
                                            <span>{{task.date}}</span>
                                            <span>·</span>
                                            <span>{{task.bytes|formatByte}}</span>
                                        </div> -->
                                    </div>
                                    <!-- 状态进度 -->
                                    <div class="item-status">
                                        <!-- 进度 -->
                                        <div class="item-progress" v-if="task.progress">
                                            <el-progress :percentage="task.progress" color="#C1CBE3" :show-text=false ></el-progress>
                                            <div class="item-progress-text">
                                                <span>{{task.speed}}</span>
                                                <span>{{task.progress + "%"}}</span>
                                            </div>
                                        </div>
                                        <!-- 状态 -->
                                        <div class="item-state" v-else>
                                            <div class="item-state-item" v-if="task.status=='Fail'">
                                                <img src="../../../assets/images/imageSaver/widthWarning.svg" >
                                                <div style="color: #E09D00">
                                                    {{$t('language.popup.upgradeAccountPopup.insufficientTraffic')}}
                                                </div>
                                            </div>
                                            <div class="item-state-item" v-if="task.status=='Done'">
                                                <img src="../../../assets/images/imageSaver/widthSuccess.svg" >
                                                <div style="color:#30A734">
                                                    {{$t('language.common.success')}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 按钮 -->
                                    <div class="item-btns">
                                        <!-- 关闭 -->
                                        <div class="item-btn" v-if="task.progress">
                                            <button class="cancel-button" @click="cancel()">{{$t('language.common.cancel')}}</button>
                                        </div>
                                        <!-- 重启或付费 -->
                                        <div class="item-btn" v-if="task.status=='Fail'">
                                            <!-- 重启 -->
                                            <div class="retry" @click="retry()"></div>
                                            <!-- 付费 -->
                                            <button class="upgrade-btn" @click="switchToPay()">
                                                <img src="../../../assets/images/imageSaver/widthUpgrade.svg" >
                                                {{$t('language.rightTopBanner.upgrade')}}
                                            </button>
                                        </div>
                                        <!-- 完成 -->
                                        <div class="item-btn" v-if="task.status&&task.status!='Fail'">
                                            <div class="view" @click="view()"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 没有任务 -->
                            <div v-if="uploadingList.length == 0" class="image_saver_task_no">
                                <img src="../../../assets/images/imageSaver/noTask.png" />
                                <div>{{ $t('language.imageSaver.noTask') }}</div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('language.imageSaver.finished')" name="finished">
                            <div class="video-task-items" v-if="taskList.length > 0">
                                <div class="video-task-item" v-for="task in finishedList" :key="task.id">
                                    <!-- 封面 -->
                                    <div class="item-cover">
                                        <el-image :src="task.thumbnailUrl" :fit="'fill'"></el-image>
                                    </div>
                                    <!-- 内容 -->
                                    <div class="item-content">
                                        <!-- 标题 -->
                                        <div class="item-content-title">{{task.fullTitle}}</div>
                                        <!-- 属性 -->
                                        <!-- <div class="item-content-attr">
                                            <span>
                                                <div class="file-type video"></div>
                                                {{task.name}}
                                            </span>
                                            <span>·</span>
                                            <span>{{task.quality}}</span>
                                            <span>·</span>
                                            <span>{{task.date}}</span>
                                            <span>·</span>
                                            <span>{{task.bytes|formatByte}}</span>
                                        </div> -->
                                    </div>
                                    <!-- 状态进度 -->
                                    <div class="item-status">
                                        <!-- 进度 -->
                                        <div class="item-progress" v-if="task.progress">
                                            <el-progress :percentage="task.progress" color="#C1CBE3" :show-text=false ></el-progress>
                                            <div class="item-progress-text">
                                                <span>{{task.speed}}</span>
                                                <span>{{task.progress + "%"}}</span>
                                            </div>
                                        </div>
                                        <!-- 状态 -->
                                        <div class="item-state" v-else>
                                            <div class="item-state-item" v-if="task.status=='Fail'">
                                                <img src="../../../assets/images/imageSaver/widthWarning.svg" >
                                                <div style="color: #E09D00">
                                                    {{$t('language.popup.upgradeAccountPopup.insufficientTraffic')}}
                                                </div>
                                            </div>
                                            <div class="item-state-item" v-if="task.status=='Done'">
                                                <img src="../../../assets/images/imageSaver/widthSuccess.svg" >
                                                <div style="color:#30A734">
                                                    {{$t('language.common.success')}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 按钮 -->
                                    <div class="item-btns">
                                        <!-- 关闭 -->
                                        <div class="item-btn" v-if="task.progress">
                                            <button class="cancel-button" @click="cancel()">{{$t('language.common.cancel')}}</button>
                                        </div>
                                        <!-- 重启或付费 -->
                                        <div class="item-btn" v-if="task.status=='Fail'">
                                            <!-- 重启 -->
                                            <div class="retry" @click="retry()"></div>
                                            <!-- 付费 -->
                                            <button class="upgrade-btn" @click="switchToPay()">
                                                <img src="../../../assets/images/imageSaver/widthUpgrade.svg" >
                                                {{$t('language.rightTopBanner.upgrade')}}
                                            </button>
                                        </div>
                                        <!-- 完成 -->
                                        <div class="item-btn" v-if="task.status&&task.status!='Fail'">
                                            <div class="view" @click="view()"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 没有任务 -->
                            <div v-if="finishedList.length == 0" class="image_saver_task_no">
                                <img src="../../../assets/images/imageSaver/noTask.png" />
                                <div>{{ $t('language.imageSaver.noTask') }}</div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '@/assets/css/tab.css';
import commonUtils from "@/js/workspace/common_util.js";
import requestUtils from '@/js/request_util.js';
export default {
    name: "videoTaskListPopup",
    data: function () {
        return {
            isShow: true,
            isLoading: false,//是否正在刷新页面
            errorNum: 0,//刷新错误次数
            activeTab: "uploading",
            taskList: [],
            hasRunning: false,//是否有运行中任务
            refreshTimer: null,//刷新定时器
        };
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        //关闭定时器
        this.closeRefreshTasks();
    },
    computed: {
        //上传中任务集合
        uploadingList() {
            let uploadingList = this.taskList.filter(task => task.status === "Running");
            this.hasRunning = uploadingList.length>0;
            return uploadingList;
        },
        //已完成任务集合
        finishedList() {
            return this.taskList.filter(task => task.status !== "Running");
        }
    },
    watch:{
        isShow(newV,oldV) {
            if(newV){
                this.init();
            }
        },
        hasRunning(newV,oldV) {
            //值变更时修改定时器状态
            newV?this.refreshTasks():this.closeRefreshTasks();
        }
    },
    methods: {
        //初始化列表
        init() {
            if(!this.isLoading){
                this.isLoading = true;
                requestUtils.doVideoSaverRequest("list_task",{ud:commonUtils.getUser().id}).then(res => {
                    this.isLoading = false;
                    console.log(res);
                    if(res.code == 200 && res.message=="success"){
                        this.errorNum = 0;
                        this.taskList = res.data;
                    }else {
                        this.errorNum++;
                        if(this.errorNum<6){
                            setTimeout(() => {
                                this.init();
                            }, 3000);
                        }
                    }
                });
            }
        },
        //刷新任务列表
        refreshTasks() {
            if(!this.refreshTimer){
                 //如果定时器不存在，则创建
                this.refreshTimer = setInterval(() => {
                    this.init();
                }, 5000);
            }
        },
        //关闭刷新任务列表
        closeRefreshTasks() {
            if(this.refreshTimer){
                clearInterval(this.refreshTimer);
            }
        },
        //关闭任务
        cancelTask(task) {
            requestUtils.doVideoSaverRequest("cancel_task",{ud:commonUtils.getUser().id,id:task.id}).then(res => {
                console.log(res);
                if(res.code == 200 && res.message=="success"){
                    //关闭成功后刷新列表
                    this.init();
                }
            });
        },
        //清空历史记录
        clearTask() {
            requestUtils.doVideoSaverRequest("clear_history",{ud:commonUtils.getUser().id}).then(res => {
                console.log(res);
                if(res.code == 200 && res.message=="success"){
                    //关闭成功后刷新列表
                    this.taskList = [];
                }
            });
        },
        optionClose() {
            this.isShow = false;
        }
    }
}
</script>

<style scoped>
#videoTaskListPopup {
    width: 1200px;
    /*no*/
    height: 750px;
    /*no*/
}

.popup-body {
    position: relative;
    overflow: auto;
    padding: 5px 20px 20px 20px;
    /*no*/
    margin: 0;
    height: calc(100% - 65px);
    /*no*/
    background: #F2F7FE;
}

.video_task_clear {
    height: 30px;
    /*no*/
    line-height: 30px;
    /*no*/
    padding: 0 10px 0 35px;
    /*no*/
    background-position: 10px center;
    /*no*/
    background-repeat: no-repeat;
    background-image: url("../../../assets/images/imageSaver/clearHistory.svg");
    font-size: 14px;
    /*no*/
    color: #5562B4;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    right: 20px;
    /*no*/
    top: 20px;
    /*no*/
}

#videoTaskListPopup .task-tab-1 >>> .el-tabs__item {
    font-size: 14px;
    /*no*/
    padding-top: 10px;
    /*no*/
    line-height: 30px;
    /*no*/
}

#videoTaskListPopup .task-tab-1 >>> .el-tabs__content {
    padding: 0;
    margin-top: 20px;
    /*no*/
}

.video-task-items {
    display: flex;
    flex-direction: column;
    gap: 15px;
    /*no*/
}

.video-task-item {
    display: flex;
    align-items: center;
    gap: 10px;
    /*no*/
    padding: 20px;
    /*no*/
    height: 114px;
    /*no*/
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #D3DCF0;
    /*no*/
}

.item-cover {
    width: 128px;
    /*no*/
    height: 72px;
    /*no*/
    flex: 0 0 128px;
    /*no*/
    justify-content: center;
    align-items: center;
    display: flex;
    background: rgba(0, 0, 0, 0.08);
}

.item-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    /*no*/
    width: 520px;
    /*no*/
}

.item-content-title {
    height: 40px;
    /*no*/
    max-height: 40px;
    /*no*/
    font-size: 18px;
    /*no*/
    font-weight: bold;
    line-height: 20px;
    /*no*/
    letter-spacing: 0em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.item-content-attr {
    display: flex;
    gap: 15px;
    /*no*/
    height: 16px;
    /*no*/
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: 16px;
    /*no*/
    letter-spacing: 0em;
    color: #6F6F6F;
}

.item-status {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 250px;
    /*no*/
    padding: 0 2px 0 30px;
    /*no*/
}

.item-progress {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.item-progress-text {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: 14px;
    /*no*/
    letter-spacing: 0em;
    margin-top: 10px;
    /*no*/
    color: #6F6F6F;
}

.item-state {
    font-size: 14px;
    /*no*/
}

.item-state-item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    /*no*/
}

.item-btns {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
}

.item-btn {
    display: flex;
    align-items: center;
}

.item-btn button{
    width: 100px;
    /*no*/
}

.cancel-button {
    border: 1px solid rgba(0, 0, 0, 0.08);
    /*no*/
    color: #000000 !important;
}

.retry {
    cursor: pointer;
    width: 24px;
    /*no*/
    height: 24px;
    /*no*/
    margin: 12px;
    /*no*/
    background: url("../../../assets/images/imageSaver/widthRetry.svg") no-repeat 100%;
}

.view {
    cursor: pointer;
    width: 24px;
    /*no*/
    height: 24px;
    /*no*/
    margin: 12px;
    /*no*/
    background: url("../../../assets/images/imageSaver/widthView.svg") no-repeat 100%;
}

.upgrade-btn {
    height: 30px;
    /*no*/
    background: linear-gradient(173deg, #FFA133 5%, #F58427 77%);
    font-size: 12px;
    /*no*/
    font-weight: bold;
    float: right;
    text-align: center;
    line-height: 30Px;
    /*no*/
    color: #fff;
    cursor: pointer;
    border-radius: 4px;
    /*no*/
}

.file-type {
    width: 16px;
    /*no*/
    height: 16px;
    /*no*/
    float: left;
    margin-right: 5px;
    /*no*/
}

</style>


// WEBPACK FOOTER //
// src/components/popup/image_saver_popups/video_task_list_popup.vue